/* tslint:disable */
/* eslint-disable */
/**
 * Content-A service
 * Content Service API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-Content_Team@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiAnalytics,
  ApiAnalyticsFromJSON,
  ApiAnalyticsFromJSONTyped,
  ApiAnalyticsToJSON,
} from './ApiAnalytics';
import {
  ApiComponent,
  ApiComponentFromJSON,
  ApiComponentFromJSONTyped,
  ApiComponentToJSON,
} from './ApiComponent';
import {
  ApiConstraint,
  ApiConstraintFromJSON,
  ApiConstraintFromJSONTyped,
  ApiConstraintToJSON,
} from './ApiConstraint';
import {
  ApiContextCardConfig,
  ApiContextCardConfigFromJSON,
  ApiContextCardConfigFromJSONTyped,
  ApiContextCardConfigToJSON,
} from './ApiContextCardConfig';
import { ApiHeader, ApiHeaderFromJSON, ApiHeaderFromJSONTyped, ApiHeaderToJSON } from './ApiHeader';
import {
  ApiInstrumentation,
  ApiInstrumentationFromJSON,
  ApiInstrumentationFromJSONTyped,
  ApiInstrumentationToJSON,
} from './ApiInstrumentation';
import { ApiLink, ApiLinkFromJSON, ApiLinkFromJSONTyped, ApiLinkToJSON } from './ApiLink';
import {
  ApiProduct,
  ApiProductFromJSON,
  ApiProductFromJSONTyped,
  ApiProductToJSON,
} from './ApiProduct';
import { ApiSku, ApiSkuFromJSON, ApiSkuFromJSONTyped, ApiSkuToJSON } from './ApiSku';
import {
  ApiStandardSkuAllOf,
  ApiStandardSkuAllOfFromJSON,
  ApiStandardSkuAllOfFromJSONTyped,
  ApiStandardSkuAllOfToJSON,
} from './ApiStandardSkuAllOf';

/**
 *
 * @export
 * @interface ApiStandardSku
 */
export interface ApiStandardSku extends ApiComponent {
  /**
   *
   * @type {Array<ApiProduct>}
   * @memberof ApiStandardSku
   */
  items?: Array<ApiProduct>;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiStandardSku
   */
  badges?: Array<string>;
  /**
   *
   * @type {Array<ApiConstraint>}
   * @memberof ApiStandardSku
   */
  constraints?: Array<ApiConstraint>;
  /**
   *
   * @type {ApiContextCardConfig}
   * @memberof ApiStandardSku
   */
  contextCardConfig?: ApiContextCardConfig;
  /**
   *
   * @type {ApiHeader}
   * @memberof ApiStandardSku
   */
  header?: ApiHeader;
  /**
   *
   * @type {string}
   * @memberof ApiStandardSku
   */
  imageOrientation?: string;
  /**
   *
   * @type {ApiLink}
   * @memberof ApiStandardSku
   */
  link?: ApiLink;
  /**
   *
   * @type {number}
   * @memberof ApiStandardSku
   */
  maxItems?: number;
  /**
   *
   * @type {number}
   * @memberof ApiStandardSku
   */
  minItems?: number;
  /**
   *
   * @type {string}
   * @memberof ApiStandardSku
   */
  placementType?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiStandardSku
   */
  prices?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiStandardSku
   */
  recipeType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardSku
   */
  dataSource?: ApiStandardSkuDataSourceEnum;
  /**
   *
   * @type {boolean}
   * @memberof ApiStandardSku
   */
  showAddToCartButton?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiStandardSku
   */
  showBundleLabel?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiStandardSku
   */
  showDealCount: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiStandardSku
   */
  showNumberOfReviews?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiStandardSku
   */
  showProductDescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiStandardSku
   */
  showStars?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiStandardSku
   */
  skuTypeOption?: string;
  /**
   *
   * @type {string}
   * @memberof ApiStandardSku
   */
  subType?: ApiStandardSkuSubTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiStandardSku
   */
  titleDetails?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof ApiStandardSku
   */
  useSavingsBadge: boolean;
  /**
   *
   * @type {Array<ApiSku>}
   * @memberof ApiStandardSku
   */
  skus?: Array<ApiSku>;
}

/**
 * @export
 */
export const ApiStandardSkuDataSourceEnum = {
  Manual: 'MANUAL',
  SegmentedPromoService: 'SEGMENTED_PROMO_SERVICE',
  VirtualBundleService: 'VIRTUAL_BUNDLE_SERVICE',
  Ruleset: 'RULESET',
} as const;
export type ApiStandardSkuDataSourceEnum = typeof ApiStandardSkuDataSourceEnum[keyof typeof ApiStandardSkuDataSourceEnum];

/**
 * @export
 */
export const ApiStandardSkuSubTypeEnum = {
  Basic: 'BASIC',
  Combo: 'COMBO',
} as const;
export type ApiStandardSkuSubTypeEnum = typeof ApiStandardSkuSubTypeEnum[keyof typeof ApiStandardSkuSubTypeEnum];

export function ApiStandardSkuFromJSON(json: any): ApiStandardSku {
  return ApiStandardSkuFromJSONTyped(json, false);
}

export function ApiStandardSkuFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiStandardSku {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    ...ApiComponentFromJSONTyped(json, ignoreDiscriminator),
    items: !exists(json, 'items')
      ? undefined
      : (json['items'] as Array<any>).map(ApiProductFromJSON),
    badges: !exists(json, 'badges') ? undefined : json['badges'],
    constraints: !exists(json, 'constraints')
      ? undefined
      : (json['constraints'] as Array<any>).map(ApiConstraintFromJSON),
    contextCardConfig: !exists(json, 'contextCardConfig')
      ? undefined
      : ApiContextCardConfigFromJSON(json['contextCardConfig']),
    header: !exists(json, 'header') ? undefined : ApiHeaderFromJSON(json['header']),
    imageOrientation: !exists(json, 'imageOrientation') ? undefined : json['imageOrientation'],
    link: !exists(json, 'link') ? undefined : ApiLinkFromJSON(json['link']),
    maxItems: !exists(json, 'maxItems') ? undefined : json['maxItems'],
    minItems: !exists(json, 'minItems') ? undefined : json['minItems'],
    placementType: !exists(json, 'placementType') ? undefined : json['placementType'],
    prices: !exists(json, 'prices') ? undefined : json['prices'],
    recipeType: !exists(json, 'recipeType') ? undefined : json['recipeType'],
    dataSource: !exists(json, 'dataSource') ? undefined : json['dataSource'],
    showAddToCartButton: !exists(json, 'showAddToCartButton')
      ? undefined
      : json['showAddToCartButton'],
    showBundleLabel: !exists(json, 'showBundleLabel') ? undefined : json['showBundleLabel'],
    showDealCount: json['showDealCount'],
    showNumberOfReviews: !exists(json, 'showNumberOfReviews')
      ? undefined
      : json['showNumberOfReviews'],
    showProductDescription: !exists(json, 'showProductDescription')
      ? undefined
      : json['showProductDescription'],
    showStars: !exists(json, 'showStars') ? undefined : json['showStars'],
    skuTypeOption: !exists(json, 'skuTypeOption') ? undefined : json['skuTypeOption'],
    subType: !exists(json, 'subType') ? undefined : json['subType'],
    titleDetails: !exists(json, 'titleDetails') ? undefined : json['titleDetails'],
    useSavingsBadge: json['useSavingsBadge'],
    skus: !exists(json, 'skus') ? undefined : (json['skus'] as Array<any>).map(ApiSkuFromJSON),
  };
}

export function ApiStandardSkuToJSON(value?: ApiStandardSku | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    ...ApiComponentToJSON(value),
    items:
      value.items === undefined ? undefined : (value.items as Array<any>).map(ApiProductToJSON),
    badges: value.badges,
    constraints:
      value.constraints === undefined
        ? undefined
        : (value.constraints as Array<any>).map(ApiConstraintToJSON),
    contextCardConfig: ApiContextCardConfigToJSON(value.contextCardConfig),
    header: ApiHeaderToJSON(value.header),
    imageOrientation: value.imageOrientation,
    link: ApiLinkToJSON(value.link),
    maxItems: value.maxItems,
    minItems: value.minItems,
    placementType: value.placementType,
    prices: value.prices,
    recipeType: value.recipeType,
    dataSource: value.dataSource,
    showAddToCartButton: value.showAddToCartButton,
    showBundleLabel: value.showBundleLabel,
    showDealCount: value.showDealCount,
    showNumberOfReviews: value.showNumberOfReviews,
    showProductDescription: value.showProductDescription,
    showStars: value.showStars,
    skuTypeOption: value.skuTypeOption,
    subType: value.subType,
    titleDetails: value.titleDetails,
    useSavingsBadge: value.useSavingsBadge,
    skus: value.skus === undefined ? undefined : (value.skus as Array<any>).map(ApiSkuToJSON),
  };
}
